import Vue from 'vue'
import ResultApp1 from './ResultApp1'

/* eslint-disable no-new */
new Vue({
    el: '#result1-app',
    template: '<ResultApp1/>',
    components: { ResultApp1 }
})


// WEBPACK FOOTER //
// ./src/privacy/content/content.js